export default __webpack_public_path__ + "static/media/Ener.9951d184.png";